import { useDentalInsuranceReportContext } from '../../..';
import { NETWORK_KEY_MAPPINGS_BY_VENDOR } from '../../../../helpers/formattedDentalCoverageTableData';
import { useInsuranceEligibilityReportContainerContext } from '../../../../providers/insurance-report-container.provider';
import { InsuranceReportTable, useInsuranceReportAccordionContext } from '../../../../shared';
import { useInsuranceTableColumnFilters } from '../../hooks/useInsuranceTableColumnFilters';
import { useInsuranceTableFilters } from '../../hooks/useInsuranceTableFilters';
import { TableDataType, TableFilterKey, Vendors } from '../../types/types';
import { InsuranceReportPrintableAccordionSection } from './InsuranceReportPrintableAccordionSection';
import { InsuranceSectionFilterContainer } from './InsuranceSectionFilterContainer';

export const MaximumsTable = () => {
  const { locationId } = useInsuranceEligibilityReportContainerContext();
  const { tablesData, vendor } = useDentalInsuranceReportContext();
  const { isPrintReport } = useInsuranceReportAccordionContext();
  const {
    InsuranceTableFilterSwitchComponent: InsuranceTableNetworkFilterSwitchComponent,
    filteredDataByFilterValue: filteredData,
  } = useInsuranceTableFilters({
    key: NETWORK_KEY_MAPPINGS_BY_VENDOR[vendor as Vendors]['networkName'] as TableFilterKey,
    tableId: 'maximum',
    tableData: tablesData.maximum || [],
    enabled: vendor === Vendors.TuuthFairy,
  });

  const { tableColumnsList, InsuranceReportTableColumnFilter } = useInsuranceTableColumnFilters({
    tableId: 'maximum',
    isPrintReport,
    locationId,
  });

  if (isPrintReport) {
    return (
      <InsuranceReportPrintableAccordionSection
        tableId='maximum'
        columns={tableColumnsList}
        vendor={vendor as Vendors}
      />
    );
  }

  return (
    <>
      <InsuranceSectionFilterContainer>
        {InsuranceTableNetworkFilterSwitchComponent}
        {InsuranceReportTableColumnFilter}
      </InsuranceSectionFilterContainer>
      <InsuranceReportTable<TableDataType>
        tableInstanceId={`insurance-report-maximums`}
        columns={tableColumnsList}
        tableData={filteredData || []}
        isPaginated={!isPrintReport}
      />
    </>
  );
};
